// extracted by mini-css-extract-plugin
module.exports = {"notFoundText":"notFound-module__notFoundText___GMnIc"};